import EnumList from "./EnumList";
import moment from "moment";

class PasswordExpirationTime extends EnumList {
  constructor() {
    super();

    this.NEVER = this.add(1, "");
    this.ONEWEEK = this.add(2, moment.duration(1, "weeks"));
    this.TWOWEEKS = this.add(3, moment.duration(2, "weeks"));
    this.FOURWEEKS = this.add(4, moment.duration(4, "weeks"));
    this.THREEMONTHS = this.add(5, moment.duration(3, "months"));
    this.ONEYEAR = this.add(6, moment.duration(1, "years"));
  }
}

export default PasswordExpirationTime;



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Enums/PasswordExpirationTime.js